import { RequestMethods } from '../../constants';
import { api } from '../../';
import { LoginEndpoints } from './constants';
import type {
  AuthTokens,
  ForgotPasswordInput,
  FunnelFoxLoginInput,
  LoginCredentialsInput,
  OtpLoginInput,
  RefreshAccessTokenInput,
  RequestOtpInput,
  ResetPasswordInput,
  UniversalLinkResponse,
} from './models';
import type { PostVoidResponse } from '~/redux/api/models';

export const loginApi = api.injectEndpoints({
  endpoints: (builder) => ({
    loginUserWithCredentials: builder.mutation<
      AuthTokens,
      LoginCredentialsInput
    >({
      query: (credentials) => ({
        url: LoginEndpoints.login,
        method: RequestMethods.POST,
        body: credentials,
      }),
    }),

    loginUserWithFunnelFox: builder.mutation<AuthTokens, FunnelFoxLoginInput>({
      query: (credentials) => ({
        url: LoginEndpoints.login,
        method: RequestMethods.POST,
        body: credentials,
      }),
    }),

    refreshAccessToken: builder.mutation<AuthTokens, RefreshAccessTokenInput>({
      query: (body) => ({
        url: LoginEndpoints.refreshAccessToken,
        method: RequestMethods.POST,
        body,
      }),
    }),

    forgotPassword: builder.mutation<PostVoidResponse, ForgotPasswordInput>({
      query: (body) => ({
        url: LoginEndpoints.forgotPassword,
        method: RequestMethods.POST,
        body,
      }),
    }),

    resetPassword: builder.mutation<PostVoidResponse, ResetPasswordInput>({
      query: (body) => ({
        url: LoginEndpoints.resetPassword,
        method: RequestMethods.POST,
        body,
      }),
    }),

    loginWithAToken: builder.mutation<AuthTokens, string>({
      query: (token) => ({
        url: LoginEndpoints.login,
        method: RequestMethods.POST,
        body: { token },
      }),
    }),

    requestOtp: builder.mutation<PostVoidResponse, RequestOtpInput>({
      query: (body) => ({
        url: LoginEndpoints.requestOtp,
        method: RequestMethods.POST,
        body,
      }),
    }),

    loginUserWithOtp: builder.mutation<AuthTokens, OtpLoginInput>({
      query: (credentials) => ({
        url: LoginEndpoints.login,
        method: RequestMethods.POST,
        body: credentials,
      }),
    }),

    getAutologinUniversalLink: builder.mutation<UniversalLinkResponse, void>({
      query: () => ({
        url: LoginEndpoints.autologinUniversalLink,
        method: RequestMethods.POST,
      }),
    }),
  }),
});

export const {
  useLoginUserWithCredentialsMutation,
  useLoginUserWithFunnelFoxMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useLoginWithATokenMutation,
  useRefreshAccessTokenMutation,
  useGetAutologinUniversalLinkMutation,
  useRequestOtpMutation,
  useLoginUserWithOtpMutation,
} = loginApi;
